import { createAction, props } from '@ngrx/store';
import { FeatureFlags } from '../../models/states/feature-flags-state.interfaces';

enum FeatureFlagsActionTypes {
  storeFeatureFlagsValues = '[flight-shop book widget] store feature flags values',
  storeFeatureFlagsValuesSuccess = '[flight-shop book widget] store feature flags success'
}

export const StoreFeatureFlagsValues = createAction(
  FeatureFlagsActionTypes.storeFeatureFlagsValues
);

export const StoreFeatureFlagsValuesSuccess = createAction(
  FeatureFlagsActionTypes.storeFeatureFlagsValuesSuccess,
  props<{
    featureFlags: FeatureFlags | null;
  }>()
);
